import React from 'react';
import { IM170ProductFilterModule } from '~/lib/data-contract';
import M170Filter from './m170-filter';

export const M170FilterBlock = (props: IM170ProductFilterModule) => {
    return <M170Filter {...props} />;
};
